export const HEALTH_PROGRAM_STATUS = {
  ACTIVE: 'active',
  AVAILABLE: 'available',
  UNAVAILABLE: 'unavailable',
};

export const JOURNEY_MANAGER_ENABLED = 'journey_manager';
